/**
 * TipTap Diff Highlighting Extension
 * 
 * Marks text with diff highlighting (additions, deletions, modifications)
 * for side-by-side diff view.
 */

import { Mark } from '@tiptap/core';

export interface DiffHighlightOptions {
  HTMLAttributes: Record<string, unknown>;
}

export const DiffHighlight = Mark.create<DiffHighlightOptions>({
  name: 'diffHighlight',
  
  addOptions() {
    return {
      HTMLAttributes: {},
    };
  },
  
  addAttributes() {
    return {
      type: {
        default: 'addition',
        parseHTML: element => element.getAttribute('data-diff-type'),
        renderHTML: attributes => {
          return {
            'data-diff-type': attributes.type,
          };
        },
      },
      operationId: {
        default: null,
        parseHTML: element => element.getAttribute('data-operation-id'),
        renderHTML: attributes => {
          if (!attributes.operationId) {
            return {};
          }
          return {
            'data-operation-id': attributes.operationId,
          };
        },
      },
    };
  },
  
  parseHTML() {
    return [
      {
        tag: 'mark[data-diff-type]',
      },
    ];
  },
  
  renderHTML({ HTMLAttributes }) {
    const type = HTMLAttributes['data-diff-type'] || 'addition';
    
    return [
      'mark',
      {
        ...HTMLAttributes,
        class: `diff-${type}`,
      },
      0,
    ];
  },
  
  addCommands() {
    return {
      setDiffHighlight: (attributes: { type: string; operationId?: string }) => ({ commands }) => {
        return commands.setMark(this.name, attributes);
      },
      unsetDiffHighlight: () => ({ commands }) => {
        return commands.unsetMark(this.name);
      },
    };
  },
});

